import { FeatureFlag } from '@sonar-software/sonar-core';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { FlowByFieldTab, FlowByNodeTab, FlowDetailsTab } from '.';
import { PeriscopeMenuTabs, PeriscopeTabArea } from '@periscopes/general';
export const FlowScope = ({ data, index }) => {
    const { sonarObjectId } = data;
    return (React.createElement(PeriscopeMenuTabs, { defaultKey: PERISCOPE_TAB_TYPES.BY_FIELD },
        React.createElement(PeriscopeTabArea, { featureFlag: FeatureFlag.DataDictionary, forceRender: true, key: PERISCOPE_TAB_TYPES.DETAILS, tab: PERISCOPE_TAB_TYPES.DETAILS },
            React.createElement(FlowDetailsTab, { sonarObjectId: sonarObjectId })),
        React.createElement(PeriscopeTabArea, { key: PERISCOPE_TAB_TYPES.BY_FIELD, tab: PERISCOPE_TAB_TYPES.BY_FIELD },
            React.createElement(FlowByFieldTab, { index: index, sonarObjectId: sonarObjectId })),
        React.createElement(PeriscopeTabArea, { key: PERISCOPE_TAB_TYPES.BY_NODE, tab: PERISCOPE_TAB_TYPES.BY_NODE },
            React.createElement(FlowByNodeTab, { index: index, sonarObjectId: sonarObjectId }))));
};
